<template>
  <div class="sf-overview-navigation" :class="outerClass">
    <div v-if="!isEmpty && !isLoading">
      <tree-menu
        v-if="overviewTree"
        :items="overviewTree"
        :expanded-items="allExpandedGroups"
        :seemless="isTreeMenuSeemless"
        :variant="variant"
        :ctrl-click="ctrlClick"
        @item-clicked="treeMenuItemClicked"
        @item-toggled="toggleOverviewGroup"
        @item-expanded="expandOverviewGroup"
      >
        <template #accent="{ itemForSlot }">
          <slot name="accent" :item-for-slot="itemForSlot" />
        </template>
        <template #itemSlot="{ itemForSlot }">
          <slot name="itemSlot" :item-for-slot="itemForSlot" />
        </template>
      </tree-menu>
    </div>
    <tree-menu-loading-state
      v-if="isLoading"
      :level-one-count="6"
      :level-two-count="3"
      :level-three-count="3"
    ></tree-menu-loading-state>
    <EmptyState
      v-if="!isLoading && isEmpty"
      :title="I18n.t('workflow_review.empty_state.sidebar_no_matches_filter')"
      image-src="empty_states/client-file.svg"
    ></EmptyState>
  </div>
</template>
<script lang="ts" setup>
import type {
  WorkflowOverviewGroup,
  WorkflowOverviewItem,
} from '@app/application/workflow-overview-navigation/types'

import { computed } from 'vue'

import EmptyState from '@app/application/communication/screens/inbox/components/empty-state.vue'
import TreeMenu from '@app/shared/vue/components/menu/tree/tree-menu.vue'
import TreeMenuLoadingState from '@app/shared/vue/components/menu/tree/tree-menu-loading-state.vue'

interface Props {
  overviewTree: Array<WorkflowOverviewItem | WorkflowOverviewGroup>
  allExpandedGroups: Record<string, boolean>
  variant?: 'default' | 'dropdown'
  isLoading: boolean
  ctrlClick?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  variant: 'default',
})

const emit =
  defineEmits<{
    itemClicked: [WorkflowOverviewItem | WorkflowOverviewGroup]
    itemExpanded: [number]
    itemToggled: [string]
  }>()

const I18n = window.I18n

const outerClass = computed<string>(() => {
  return isTreeMenuSeemless.value ? '' : 'sf-overview-navigation--dropdown'
})

const isTreeMenuSeemless = computed<boolean>(() => {
  return props.variant === 'default'
})

const isEmpty = computed<boolean>(() => {
  return props.overviewTree?.length === 0
})

function expandOverviewGroup(itemId: number) {
  emit('itemExpanded', itemId)
}

function treeMenuItemClicked(
  item: WorkflowOverviewItem | WorkflowOverviewGroup
) {
  emit('itemClicked', item)
}

function toggleOverviewGroup(group: string) {
  emit('itemToggled', group)
}
</script>
<style scoped lang="scss">
.sf-overview-navigation {
  &--dropdown {
    max-height: calc(100vh - 200px);
    overflow-y: auto;
  }
}

.sf-tree-menu-wrapper .sf-tree-menu__item-icon {
  display: inline-block;
  margin-left: 6px;
}
</style>
